import ComponentMixin from '../smart/component.m.js';

class Base extends HTMLElement {
    constructor(...args) {
        super(...args);
    }
}

export default class Drawer extends ComponentMixin(Base) {
    constructor(...args) {
        // Constructor caveat https://github.com/WebReflection/document-register-element/
        const _ = super(...args);
        return _;
    }

    get defaults() {
        return {
            duration: 500,
            open: false,
            align: 'top',
            embeded: false
        }
    }

    static get observedAttributes() {
        return super.observedAttributes.concat(['open', 'align', 'embeded', 'ontoggledrawer']);
    }

    /**
     * Method to set default values of properties and syncing the needed properties
     */
    setup() {
        super.setup();

        this._duration = this.defaults.duration;
        this._open = this.defaults.open;
        this._align = this.defaults.align;
        this._embeded = this.defaults.embeded;

        this.syncProp('open');
        this.syncProp('align');
        this.syncProp('embeded');

        this.on(['toggledrawer']);
    }

    get toggleElement() {
        return this.querySelector('toggle, [role="toggle"]');
    }

    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);

        if (name == 'align') {
            this.syncAttr(name, newValue, 'string');
        } else if (name == 'ontoggledrawer') {
            this.syncAttr(name, newValue, 'function');
        } else {
            this.syncAttr(name, newValue, 'boolean');
        }
    }

    propertyChangedCallback(name, oldValue, newValue) {
        if (!this._isRendered) { return; }
        switch (name) {
            case 'open': this.toggle(this.open);
                break;
            case 'embeded': this.updatePositionsToEmbed();
                break;
        }
    }

    connectedCallback() {
        super.connectedCallback();
        window.requestAnimationFrame(() => {
            this.render();
        });
    }

    render() {
        this.updatePositionsToEmbed();
        // Create the toggle element
        if (!this.toggleElement) {
            var toggleElement;
            toggleElement = document.createElement('toggle');
            toggleElement.innerHTML = '<a href="#" onclick="return false;" class="zs-icon zs-size-xl zs-icon-carat-up"></a>';
            this.appendChild(toggleElement);
        }

        // Toggle the drawer when it is initially open to avoid animations on load.
        if (this.open) {
            this.setAttribute('open', '');
            this.style.transform = 'translateX(0%)';
            if (this.embeded) {
                this.style.position = 'absolute';
            }
            this.renderArrow();
        }
        this.on('click', this, this.toggleElement);
        this._isRendered = true;
    }

    onclick(event) {
        if (event.currentTarget == this.toggleElement) {
            this.open = !this.open;
        }
    }

    ontoggledrawer() {

    }

    /**
     * Method to toggle the state of drawer based on the boolean parameter passed to it
     * @param {Boolean} open 
     */
    toggle(open) {
        var transformStartPoint = '';
        var transformEndPoint = '';
        switch (this.align) {
            case 'top':
                if (open) {
                    transformStartPoint = 'translateY(-100%)';
                    transformEndPoint = 'translateY(0%)';
                } else {
                    transformStartPoint = 'translateY(0%)';
                    transformEndPoint = 'translateY(-100%)';
                }
                break;

            case 'left':
                if (open) {
                    transformStartPoint = 'translateX(-100%)';
                    transformEndPoint = 'translateX(0%)';
                } else {
                    transformStartPoint = 'translateX(0%)';
                    transformEndPoint = 'translateX(-100%)';
                }
                break;

            case 'right':
                if (open) {
                    transformStartPoint = 'translateX(100%)';
                    transformEndPoint = 'translateX(0%)';
                } else {
                    transformStartPoint = 'translateX(0%)';
                    transformEndPoint = 'translateX(100%)';
                }
                break;

            case 'bottom':
                if (open) {
                    transformStartPoint = 'translateY(100%)';
                    transformEndPoint = 'translateY(0%)';
                } else {
                    transformStartPoint = 'translateY(0%)';
                    transformEndPoint = 'translateY(100%)';
                }
                break;
        }
        this.renderArrow();
        var self = this;
        this.animate(
            [
                {
                    transform: transformStartPoint,
                },
                {
                    transform: transformEndPoint,
                }
            ],
            {
                duration: 500,
                fill: 'forwards',
                complete: this.animationCallBack()
            }
        );

    }
    animationCallBack() {
        if (this._isCreated) {
            /**
            * After ending sliding drawer
            * @event toggle
            * @type {object}
            */
            this.fire('toggledrawer');
        }
    }

    /**
     * Method to update position of parent and the element to handle embeded drawers
     */
    updatePositionsToEmbed() {
        if (this.embeded && this.parentElement) {
            if (this.parentElement.position == 'static' || this.parentElement.position == null || this.parentElement.position == '') {
                this.parentElement.style.position = 'relative';
            }
            this.parentElement.style.overflow = 'hidden';
            this.style.position = 'absolute';
            this.style.zIndex = 1;
        }
    }

    /**
     * Method to render the default arrows when no toggle element is provided by user
     */
    renderArrow() {
        var toggleAnchor = this.toggleElement.querySelector('a');

        if (toggleAnchor && (toggleAnchor.classList.contains("zs-icon-carat-up") || toggleAnchor.classList.contains("zs-icon-carat-down"))) {
            if (this.open) {
                toggleAnchor.classList.remove("zs-icon-carat-up");
                toggleAnchor.classList.add("zs-icon-carat-down");
            } else {
                toggleAnchor.classList.add("zs-icon-carat-up");
                toggleAnchor.classList.remove("zs-icon-carat-down");
            }
        }
    }

}

Drawer.is = 'zs-drawer';